// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bs-primary: #0055D2;
    --bs-secondary: #232323;
    --bs-body-bg: #F8F8F8;
    --bs-light: #F8F8F8;
    --bs-dark: #232323;
    --bs-info: #00BFFF;
  }
  
  body {
    background-color: var(--bs-body-bg);
    color: var(--bs-dark);
  }
  
  .card {
    background-color: var(--bs-light);
    border-color: var(--bs-primary);
  }
  
  .btn-primary {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary);
  }
  
  /* .btn-primary:hover {
    background-color: darken(var(--bs-primary), 50%);
    border-color: darken(var(--bs-primary), 50%);
  } */
  #projectsMenu.collapse.show + .btn .ms-auto {
    transform: rotate(90deg); /* Rotate chevron when expanded */
    transition: transform 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/custom.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;;EAEA;IACE,iCAAiC;IACjC,+BAA+B;EACjC;;EAEA;IACE,mCAAmC;IACnC,+BAA+B;EACjC;;EAEA;;;KAGG;EACH;IACE,wBAAwB,EAAE,iCAAiC;IAC3D,sCAAsC;AAC1C","sourcesContent":[":root {\n    --bs-primary: #0055D2;\n    --bs-secondary: #232323;\n    --bs-body-bg: #F8F8F8;\n    --bs-light: #F8F8F8;\n    --bs-dark: #232323;\n    --bs-info: #00BFFF;\n  }\n  \n  body {\n    background-color: var(--bs-body-bg);\n    color: var(--bs-dark);\n  }\n  \n  .card {\n    background-color: var(--bs-light);\n    border-color: var(--bs-primary);\n  }\n  \n  .btn-primary {\n    background-color: var(--bs-primary);\n    border-color: var(--bs-primary);\n  }\n  \n  /* .btn-primary:hover {\n    background-color: darken(var(--bs-primary), 50%);\n    border-color: darken(var(--bs-primary), 50%);\n  } */\n  #projectsMenu.collapse.show + .btn .ms-auto {\n    transform: rotate(90deg); /* Rotate chevron when expanded */\n    transition: transform 0.2s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
